import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { environment } from '../../environments/environment';

@Directive({
    selector: '[kdSldsIcon]'
})
export class SldsIconDirective implements OnInit {

    @Input()
    kdSldsIcon: string;

    constructor(
        private elementRef: ElementRef,
    ) { }

    ngOnInit() {
        const element: HTMLElement = this.elementRef.nativeElement;
        const href = `${environment.sldsConfig.svgPath}utility-sprite/svg/symbols.svg#${this.kdSldsIcon}`;

        element.innerHTML = `
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${href}"></use>
        `;
    }
}
